import "../../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ToastContainer from "sushiweb/ToastContainer";
import TrackPageLoad from "components/core/Route/TrackPageLoad";
import TrackClick from "components/core/Route/TrackClick";
import RkLogin from "./pages/rk/RkLogin";
import RkHome from "./pages/rk/RkHome";
import MarkReturn from "./pages/rk/MarkReturn";
import OutletOrders from "./pages/rk/OutletOrders";
import MarkOrderReturn from "./pages/rk/MarkOrderReturn";
import ViewReturns from "./pages/rk/ViewReturns";
import ViewReturnDetails from "./pages/rk/ViewReturnDetails";
import { RkProtectedRoute, RkPublicOnlyRoute } from "./components/RkAuthRoute";

function ExternalApp() {
  return (
    <ToastContainer>
      <div className="App">
        <Router>
          <TrackPageLoad />
          <TrackClick />
          <Routes>
            <Route path="/" element={<Navigate to="/rk" replace />} />
            <Route element={<RkPublicOnlyRoute />}>
              <Route path="/rk" element={<RkLogin />} />
            </Route>
            <Route element={<RkProtectedRoute />}>
              <Route path="/rk/home" element={<RkHome />} />
              <Route path="/rk/mark-return" element={<MarkReturn />} />
              <Route path="/rk/view-return" element={<ViewReturns />} />
              <Route
                path="/rk/view-return/:orderId"
                element={<ViewReturnDetails />}
              />
              <Route
                path="/rk/outlets/:outletId/orders"
                element={<OutletOrders />}
              />
              <Route
                path="/rk/outlets/:outletId/orders/:orderId/return"
                element={<MarkOrderReturn />}
              />
            </Route>
            <Route path="*" element={<Navigate to="/rk" replace />} />
          </Routes>
        </Router>
      </div>
    </ToastContainer>
  );
}

export default ExternalApp;
